import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const DEFlagIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M10.0002 18.8872C5.09102 18.8872 1.11133 14.9075 1.11133 9.99826C1.11133 5.08907 5.09102 1.10937 10.0002 1.10938C14.9094 1.10938 18.8891 5.08907 18.8891 9.99826C18.8891 14.9075 14.9094 18.8872 10.0002 18.8872Z"
        fill="#D90026"
      />
      <path
        d="M18.3295 6.88715C17.0684 3.51234 13.8149 1.10938 10.0002 1.10938C6.18553 1.10937 2.93208 3.51234 1.67098 6.88715L18.3295 6.88715Z"
        fill="black"
      />
      <path
        d="M1.67098 13.1094C2.93208 16.4842 6.18553 18.8872 10.0002 18.8872C13.8149 18.8872 17.0684 16.4842 18.3295 13.1094L1.67098 13.1094Z"
        fill="#FFDB44"
      />
    </BaseIcon>
  );
};

DEFlagIcon.displayName = 'DEFlagIcon';
